var _rect, _g, _rect2, _rect3, _rect4, _path, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExploreBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 64,
    viewBox: "0 0 176 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_629_6636",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: 6,
    width: 188,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 164,
    height: 40,
    rx: 20,
    stroke: "url(#paint0_angular_629_6636)",
    strokeWidth: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_629_6636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3403 51.5093C26.5418 51.0603 26.1089 50.6263 25.6611 50.8283C25.564 50.8732 25.4894 50.9481 25.4446 51.0453C25.2356 51.4944 25.676 51.9284 26.1238 51.7264C26.2209 51.6815 26.2955 51.6066 26.3403 51.5093Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4892 48.732C14.6907 48.283 14.2578 47.8489 13.81 48.051C13.713 48.0959 13.6383 48.1707 13.5935 48.268C13.3846 48.717 13.8249 49.1511 14.2727 48.949C14.3698 48.9041 14.4444 48.8293 14.4892 48.732Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4891 36.732C37.6911 36.283 37.2571 35.8489 36.808 36.051C36.7108 36.0959 36.6359 36.1707 36.591 36.268C36.3889 36.717 36.823 37.1511 37.272 36.949C37.3693 36.9041 37.4442 36.8293 37.4891 36.732Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9492 48.6905C51.1507 48.2415 50.7178 47.8074 50.2699 48.0095C50.1729 48.0544 50.0983 48.1292 50.0535 48.2265C49.8445 48.6755 50.2849 49.1096 50.7327 48.9075C50.8297 48.8626 50.9044 48.7878 50.9492 48.6905Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5935 58.732C42.3846 58.283 42.8249 57.8489 43.2728 58.051C43.3698 58.0959 43.4444 58.1707 43.4892 58.268C43.6907 58.717 43.2578 59.1511 42.81 58.949C42.7129 58.9041 42.6383 58.8293 42.5935 58.732Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5935 62.732C17.3846 62.283 17.8249 61.8489 18.2727 62.051C18.3698 62.0959 18.4444 62.1707 18.4892 62.268C18.6907 62.717 18.2578 63.1511 17.81 62.949C17.713 62.9041 17.6383 62.8293 17.5935 62.732Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3403 15.5093C28.5418 15.0603 28.1089 14.6263 27.6611 14.8283C27.564 14.8732 27.4894 14.9481 27.4446 15.0453C27.2356 15.4944 27.676 15.9284 28.1238 15.7264C28.2209 15.6815 28.2955 15.6066 28.3403 15.5093Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4892 12.732C16.6907 12.283 16.2578 11.8489 15.81 12.051C15.713 12.0959 15.6383 12.1707 15.5935 12.268C15.3846 12.717 15.8249 13.1511 16.2727 12.949C16.3698 12.9041 16.4444 12.8293 16.4892 12.732Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5935 22.732C44.3846 22.283 44.8249 21.8489 45.2728 22.051C45.3698 22.0959 45.4444 22.1707 45.4892 22.268C45.6907 22.717 45.2578 23.1511 44.81 22.949C44.7129 22.9041 44.6383 22.8293 44.5935 22.732Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5935 26.732C19.3846 26.283 19.8249 25.8489 20.2727 26.051C20.3698 26.0959 20.4444 26.1707 20.4892 26.268C20.6907 26.717 20.2578 27.1511 19.81 26.949C19.713 26.9041 19.6383 26.8293 19.5935 26.732Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.949164 33.6905C1.15069 33.2415 0.717779 32.8074 0.269942 33.0095C0.172911 33.0544 0.098288 33.1292 0.0535044 33.2265C-0.155486 33.6755 0.284866 34.1096 0.732703 33.9075C0.829734 33.8626 0.90438 33.7878 0.949164 33.6905Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94916 53.6905C5.15069 53.2415 4.71778 52.8074 4.26994 53.0095C4.17291 53.0544 4.09829 53.1292 4.0535 53.2265C3.84451 53.6755 4.28487 54.1096 4.7327 53.9075C4.82973 53.8626 4.90438 53.7878 4.94916 53.6905Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59088 21.7086C6.38935 21.2595 6.82225 20.8255 7.27008 21.0275C7.36711 21.0724 7.44175 21.1473 7.48654 21.2446C7.69553 21.6936 7.25515 22.1277 6.80732 21.9256C6.71029 21.8807 6.63566 21.8058 6.59088 21.7086Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.591 36.732C11.3889 36.283 11.823 35.8489 12.272 36.051C12.3693 36.0959 12.4442 36.1707 12.4891 36.268C12.6911 36.717 12.2571 37.1511 11.808 36.949C11.7107 36.9041 11.6359 36.8293 11.591 36.732Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.489 61.732C132.691 61.283 132.258 60.8489 131.81 61.051C131.713 61.0959 131.638 61.1707 131.594 61.268C131.385 61.717 131.825 62.1511 132.273 61.949C132.37 61.9041 132.444 61.8293 132.489 61.732Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.591 37.7086C142.389 37.2595 142.822 36.8255 143.27 37.0275C143.367 37.0724 143.442 37.1473 143.487 37.2446C143.696 37.6936 143.255 38.1277 142.807 37.9256C142.71 37.8807 142.636 37.8058 142.591 37.7086Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.591 62.732C155.389 62.283 155.823 61.8489 156.272 62.051C156.369 62.0959 156.444 62.1707 156.489 62.268C156.691 62.717 156.257 63.1511 155.808 62.949C155.711 62.9041 155.636 62.8293 155.591 62.732Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.591 45.732C162.389 45.283 162.823 44.8489 163.272 45.051C163.369 45.0959 163.444 45.1707 163.489 45.268C163.691 45.717 163.257 46.1511 162.808 45.949C162.711 45.9041 162.636 45.8293 162.591 45.732Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.364 49.1783C146.565 48.7293 146.132 48.2952 145.685 48.4973C145.587 48.5422 145.513 48.617 145.468 48.7143C145.259 49.1633 145.699 49.5974 146.147 49.3953C146.244 49.3504 146.319 49.2756 146.364 49.1783Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.489 25.732C134.691 25.283 134.258 24.8489 133.81 25.051C133.713 25.0959 133.638 25.1707 133.594 25.268C133.385 25.717 133.825 26.1511 134.273 25.949C134.37 25.9041 134.444 25.8293 134.489 25.732Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.949 12.6905C125.151 12.2415 124.718 11.8074 124.27 12.0095C124.173 12.0544 124.098 12.1292 124.054 12.2265C123.845 12.6755 124.285 13.1096 124.733 12.9075C124.83 12.8626 124.904 12.7878 124.949 12.6905Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.591 26.732C157.389 26.283 157.823 25.8489 158.272 26.051C158.369 26.0959 158.444 26.1707 158.489 26.268C158.691 26.717 158.257 27.1511 157.808 26.949C157.711 26.9041 157.636 26.8293 157.591 26.732Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.591 9.732C164.389 9.28297 164.823 8.84891 165.272 9.05097C165.369 9.09587 165.444 9.17071 165.489 9.268C165.691 9.71703 165.257 10.1511 164.808 9.94903C164.711 9.90413 164.636 9.82929 164.591 9.732Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.364 13.1783C148.565 12.7293 148.132 12.2952 147.685 12.4973C147.587 12.5422 147.513 12.617 147.468 12.7143C147.259 13.1633 147.699 13.5974 148.147 13.3953C148.244 13.3504 148.319 13.2756 148.364 13.1783Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.949 35.6905C162.151 35.2415 161.718 34.8074 161.27 35.0095C161.173 35.0544 161.098 35.1292 161.054 35.2265C160.845 35.6755 161.285 36.1096 161.733 35.9075C161.83 35.8626 161.904 35.7878 161.949 35.6905Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.591 25.7086C173.389 25.2595 173.822 24.8255 174.27 25.0275C174.367 25.0724 174.442 25.1473 174.487 25.2446C174.696 25.6936 174.255 26.1277 173.807 25.9256C173.71 25.8807 173.636 25.8058 173.591 25.7086Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.591 46.732C174.389 46.283 174.823 45.8489 175.272 46.051C175.369 46.0959 175.444 46.1707 175.489 46.268C175.691 46.717 175.257 47.1511 174.808 46.949C174.711 46.9041 174.636 46.8293 174.591 46.732Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_629_6636)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 19,
    width: 162,
    height: 38,
    rx: 19,
    stroke: "url(#paint1_angular_629_6636)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 19,
    width: 162,
    height: 38,
    rx: 19,
    stroke: "url(#paint2_angular_629_6636)",
    strokeWidth: 2
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 18.5,
    width: 163,
    height: 39,
    rx: 19.5,
    stroke: "url(#paint3_angular_629_6636)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 164,
    height: 40,
    rx: 20,
    fill: "white",
    fillOpacity: 0.01
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 164,
    height: 40,
    rx: 20,
    fill: "url(#paint4_radial_629_6636)",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.48 43V32.92H63.78V33.907H58.509V37.393H62.94V38.38H58.509V42.013H63.78V43H57.48ZM65.1844 43L68.6774 37.897L65.2754 32.92H66.5214L69.2864 37.036L72.0514 32.92H73.3044L69.9024 37.897L73.3884 43H72.1424L69.2864 38.765L66.4374 43H65.1844ZM75.0746 43V32.92H78.9666C79.0646 32.92 79.1743 32.9247 79.2956 32.934C79.4216 32.9387 79.5476 32.9527 79.6736 32.976C80.2009 33.0553 80.6466 33.2397 81.0106 33.529C81.3793 33.8137 81.6569 34.173 81.8436 34.607C82.0349 35.041 82.1306 35.5217 82.1306 36.049C82.1306 36.5717 82.0349 37.05 81.8436 37.484C81.6523 37.918 81.3723 38.2797 81.0036 38.569C80.6396 38.8537 80.1963 39.0357 79.6736 39.115C79.5476 39.1337 79.4216 39.1477 79.2956 39.157C79.1743 39.1663 79.0646 39.171 78.9666 39.171H76.1036V43H75.0746ZM76.1036 38.191H78.9386C79.0226 38.191 79.1206 38.1863 79.2326 38.177C79.3446 38.1677 79.4543 38.1513 79.5616 38.128C79.9069 38.0533 80.1893 37.911 80.4086 37.701C80.6326 37.491 80.7983 37.2413 80.9056 36.952C81.0176 36.6627 81.0736 36.3617 81.0736 36.049C81.0736 35.7363 81.0176 35.4353 80.9056 35.146C80.7983 34.852 80.6326 34.6 80.4086 34.39C80.1893 34.18 79.9069 34.0377 79.5616 33.963C79.4543 33.9397 79.3446 33.9257 79.2326 33.921C79.1206 33.9117 79.0226 33.907 78.9386 33.907H76.1036V38.191ZM84.2238 43V32.92H85.2528V42.013H90.0408V43H84.2238ZM95.6018 43.21C94.5984 43.21 93.7514 42.9883 93.0608 42.545C92.3701 42.097 91.8474 41.4787 91.4928 40.69C91.1381 39.9013 90.9608 38.9913 90.9608 37.96C90.9608 36.9287 91.1381 36.0187 91.4928 35.23C91.8474 34.4413 92.3701 33.8253 93.0608 33.382C93.7514 32.934 94.5984 32.71 95.6018 32.71C96.6098 32.71 97.4568 32.934 98.1428 33.382C98.8335 33.8253 99.3561 34.4413 99.7108 35.23C100.07 36.0187 100.25 36.9287 100.25 37.96C100.25 38.9913 100.07 39.9013 99.7108 40.69C99.3561 41.4787 98.8335 42.097 98.1428 42.545C97.4568 42.9883 96.6098 43.21 95.6018 43.21ZM95.6018 42.223C96.3904 42.223 97.0484 42.0433 97.5758 41.684C98.1031 41.3247 98.4974 40.8253 98.7588 40.186C99.0248 39.542 99.1578 38.8 99.1578 37.96C99.1578 37.12 99.0248 36.3803 98.7588 35.741C98.4974 35.1017 98.1031 34.6023 97.5758 34.243C97.0484 33.8837 96.3904 33.7017 95.6018 33.697C94.8131 33.697 94.1574 33.8767 93.6348 34.236C93.1121 34.5953 92.7178 35.097 92.4518 35.741C92.1904 36.3803 92.0574 37.12 92.0528 37.96C92.0481 38.8 92.1764 39.5397 92.4378 40.179C92.7038 40.8137 93.1004 41.313 93.6278 41.677C94.1551 42.0363 94.8131 42.2183 95.6018 42.223ZM102.212 43V32.92H106.104C106.202 32.92 106.311 32.9247 106.433 32.934C106.559 32.9387 106.685 32.9527 106.811 32.976C107.338 33.0553 107.784 33.2397 108.148 33.529C108.516 33.8137 108.794 34.173 108.981 34.607C109.172 35.041 109.268 35.5217 109.268 36.049C109.268 36.8097 109.067 37.47 108.666 38.03C108.264 38.59 107.69 38.9423 106.944 39.087L106.587 39.171H103.241V43H102.212ZM108.316 43L106.328 38.898L107.315 38.52L109.499 43H108.316ZM103.241 38.191H106.076C106.16 38.191 106.258 38.1863 106.37 38.177C106.482 38.1677 106.591 38.1513 106.699 38.128C107.044 38.0533 107.326 37.911 107.546 37.701C107.77 37.491 107.935 37.2413 108.043 36.952C108.155 36.6627 108.211 36.3617 108.211 36.049C108.211 35.7363 108.155 35.4353 108.043 35.146C107.935 34.852 107.77 34.6 107.546 34.39C107.326 34.18 107.044 34.0377 106.699 33.963C106.591 33.9397 106.482 33.9257 106.37 33.921C106.258 33.9117 106.16 33.907 106.076 33.907H103.241V38.191ZM111.604 43V32.92H117.904V33.907H112.633V37.393H117.064V38.38H112.633V42.013H117.904V43H111.604Z",
    fill: "url(#paint5_linear_629_6636)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 18.5,
    width: 163,
    height: 39,
    rx: 19.5,
    stroke: "white",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_629_6636",
    x: 0,
    y: 12,
    width: 176,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_629_6636"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_629_6636",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88 38) scale(110.522 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838542,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_629_6636",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88 38) scale(110.522 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838542,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_629_6636",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88 38) scale(110.522 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838542,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_angular_629_6636",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88 38) scale(110.522 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838542,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_629_6636",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88 104) rotate(90) scale(43 176.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_629_6636",
    x1: 88,
    y1: 26,
    x2: 88,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885417,
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreBtn);
export default __webpack_public_path__ + "static/media/explore_btn.849c68f8c1c3310a8a818f5f0c4ff430.svg";
export { ForwardRef as ReactComponent };